<div class="card h-100">
  <img class="card-img-top" [src]="card.image" alt="" />
  <div class="card-body">
    <h5 class="card-title">{{ card.titleKey | msg | async }}</h5>
    <p class="card-text">
      {{ card.descriptionKey | msg | async }}
    </p>
  </div>
  <div class="card-footer">
    <div class="text-end">
      <a class="btn btn-danger px-4" (click)="card.actionCallbackFunction()"
        ><svg-icon
          class="icon-arrow"
          [src]="'../../../assets/images/icons/arrow-right.svg'"
        ></svg-icon
      ></a>
    </div>
  </div>
</div>
